import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import {
  TbLayersLinked,
  TbComponents,
  TbArrowsExchange,
  TbChartArcs,
  TbShield,
} from "react-icons/tb";
import "../../styles/PositioningSection.css";

const pillars = [
  {
    icon: <TbLayersLinked size={24} />,
    title: "Arquitectura modular",
    desc: "Cada solución es un módulo que se integra con los demás. Empezás por donde más duele y expandís sin rehacer.",
  },
  {
    icon: <TbComponents size={24} />,
    title: "Ecosistema conectado",
    desc: "ERP, MES, Gemelo Digital e IA no son productos aislados. Son capas de una misma arquitectura.",
  },
  {
    icon: <TbArrowsExchange size={24} />,
    title: "Datos en tiempo real",
    desc: "Cada pieza del sistema habla con las demás. Cero silos. Una sola fuente de verdad.",
  },
  {
    icon: <TbChartArcs size={24} />,
    title: "Decisiones predictivas",
    desc: "No solo registramos lo que pasa: proyectamos lo que va a pasar para que actúes antes del problema.",
  },
  {
    icon: <TbShield size={24} />,
    title: "Industria + Software a medida",
    desc: "Cubrimos operaciones industriales complejas y también desarrollamos sistemas propios para cualquier modelo de negocio.",
  },
];

const PositioningSection = () => (
  <section className="pos-root" id="identidad">
    <div className="container">

      {/* Badge */}
      <Fade direction="down" triggerOnce duration={700}>
        <div className="eco-badge mx-auto mb-4">
          <TbLayersLinked size={14} style={{ marginRight: 6 }} />
          Nuestra identidad
        </div>
      </Fade>

      {/* Headline */}
      <Fade direction="up" triggerOnce duration={800} delay={100}>
        <h2 className="eco-main-title text-center text-white">
          No desarrollamos software.{" "}
          <span className="highlight">Diseñamos arquitectura digital.</span>
        </h2>
      </Fade>

      <Fade direction="up" triggerOnce duration={700} delay={200}>
        <p className="eco-main-sub text-center text-white">
          Todo lo que hacemos responde a una estructura modular pensada para escalar,
          conectar y crecer con tu operación, sin empezar de cero cada vez.
        </p>
      </Fade>

      {/* Pillars */}
      <div className="pos-grid">
        {pillars.map((p, i) => (
          <Slide direction="up" triggerOnce duration={600} delay={i * 90} key={p.title}>
            <div className="pos-card">
              <span className="pos-icon">{p.icon}</span>
              <h4 className="pos-title">{p.title}</h4>
              <p className="pos-desc">{p.desc}</p>
            </div>
          </Slide>
        ))}
      </div>

      {/* Architecture diagram hint */}
      <Fade direction="up" triggerOnce duration={700} delay={550}>
        <div className="pos-arch-strip">
          {["ERP", "MES", "Gemelo Digital", "IA", "Dev a Medida"].map((label, i) => (
            <React.Fragment key={label}>
              <span className="pos-arch-node">{label}</span>
              {i < 4 && <span className="pos-arch-connector">→</span>}
            </React.Fragment>
          ))}
        </div>
      </Fade>

    </div>
  </section>
);

export default PositioningSection;
